import {
  CLEAR_CREATE_TRANSACTION,
  SELECT_DISCOUNT_PROGRAM,
  SET_BIDS_PAYMENT_TYPE_TEXT_VALUE,
  SET_BIDS_TEXT_VALUE,
  SET_DROPDOWN_VALUE,
  SET_PARENT_DEALER_ACCOUNT_ID,
  SET_SALESPERSON_ID, SET_SALESPERSON_NAME,
  SET_TEXT_VALUE,
  SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE,
  SET_VIEW_TRANSACTION
} from "../action";
import { LOST, WON } from "../utilities/constants";
import { formatDate } from "../utilities/utils";
import {
  bids as competitorBid,
  paymentType,
  transactions,
} from "./initial-store";

const initialState = transactions;

function transactionReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_DROPDOWN_VALUE:
      newState = {
        ...state,
        [action.payload.domainName]: action.payload.domainValue,
      };
      return newState;
    case SELECT_DISCOUNT_PROGRAM:
      newState = {...state, discountPrograms: action.payload}
      return newState;
    case SET_TEXT_VALUE:
      newState = {
        ...state,
        [action.payload.textKey]: action.payload.textValue,
      };
      return newState;
    case SET_SALESPERSON_ID:
      newState = {
        ...state,
        salePersonID: action.payload,
      };
      return newState;
    case SET_SALESPERSON_NAME:
      newState = {
        ...state,
        salesPersonName: action.payload,
      };
      return newState;
    case SET_PARENT_DEALER_ACCOUNT_ID:
      newState = {
        ...state,
        [action.payload.textKey]: action.payload.textValue,
      };
      return newState;
    case SET_BIDS_TEXT_VALUE:
      if (action.payload.textKey === "compBids") {
        const currentBids = state.bids.length;
        const expectedBids = Number(action.payload.textValue) + 1;
        const incrementInBids = expectedBids > currentBids;
        const delta = incrementInBids
          ? expectedBids - currentBids
          : currentBids - expectedBids;
        if (incrementInBids) {
          const bidsToBeAdded = Array.from(
            { length: delta },
            (_, idx) => idx + currentBids
          ).map((bidNumber) => {
            return {
              ...competitorBid,
              bidType: `C${bidNumber}`,
              dealResult: state.bids[0].dealResult === WON ? LOST : WON,
              currency: state.bids[0].currency,
              category: state.bids[0].category,
              paymentType: {
                ...state.paymentType,
                paymentType: state.bids[0].paymentType.paymentType,
              },
            };
          });
          newState = { ...state, bids: [...state.bids, ...bidsToBeAdded] };
          return newState;
        } else {
          newState = { ...state, bids: [...state.bids.slice(0, expectedBids)] };
          return newState;
        }
      } else {
        const bidToBeUpdated = state.bids.map((bid) => {
          if (bid.bidType === action.payload.bidNum) {
            return {
              ...bid,
              [action.payload.textKey]: action.payload.textValue,
            };
          } else {
            return bid;
          }
        });
        newState = { ...state, bids: [...bidToBeUpdated] };
        return newState;
      }

    case SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE:
      newState = {
        ...state,
        bids: state.bids.map((bid) => {
          return {
            ...bid,
            paymentType: {
              ...paymentType,
              [action.payload.domainName]: action.payload.domainValue,
            },
          };
        }),
      };
      return newState;

    case SET_BIDS_PAYMENT_TYPE_TEXT_VALUE:
      const paymentBidToBeUpdated = state.bids.map((bid) => {
        if (bid.bidType === action.payload.bidNum) {
          return {
            ...bid,
            paymentType: {
              ...bid.paymentType,
              [action.payload.textKey]: action.payload.textValue,
            },
          };
        } else {
          return bid;
        }
      });
      newState = { ...state, bids: [...paymentBidToBeUpdated] };
      return newState;

    case SET_VIEW_TRANSACTION:
      let transactionsData = {
        customerName: action.payload.customerName,
        dealMarket: action.payload.marketSegment,
        salePersonID: action.payload.salesPersonId,
        salesPersonName: action.payload.salesPersonName,
        txnId: action.payload.txnId,
        parentDealerAccountID: action.payload.parentDealerAccountID,
        dealType: action.payload.dealType,
        quantity: action.payload.quantity,
        compBids: (action.payload.bids.length - 1).toString(),
        discountPrograms:
          action.payload.discountPrograms !== null
            ? action.payload.discountPrograms
            : [],
        txnDate: formatDate(action.payload.txnDate),
        remarks: action.payload.comments,
        customerPostalCode: "",
        dealKey: action.payload.dealerDealKey,
        saleReason: action.payload.saleReason,
        currency: action.payload.bids[0].currency,
        txnStatus: action.payload.txnStatus,
        bids: action.payload.bids.map((value) => ({
          id: value.id,
          addnlDlrCost:
            value.bidType === "JD"
              ? value.addnDlrCost.toString()
              : value.addnDlrCost,
          saleReason: action.payload.saleReason,
          bidType: value.bidType,
          category: value.category,
          dealerName: value.dealerName,
          dealResult: value.dealResult,
          dlrMarginPct:
            value.bidType === "JD"
              ? value.dlrMargin.toString()
              : value.dlrMargin,
          extAttachCost:
            value.bidType === "JD"
              ? value.partsAttCost.toString()
              : value.partsAttCost,
          extAttachDesc: value.bidType === "JD" ? value.partsAttDesc : "",
          finBuyDownCost:
            value.bidType === "JD"
              ? value.finBuydownCost.toString()
              : value.finBuydownCost,
          freightPDICost:
            value.bidType === "JD"
              ? value.frtPdiCost.toString()
              : value.frtPdiCost,
          machineOrigMDP:
            value.bidType === "JD"
              ? value.machOrigMdp.toString()
              : value.machOrigMdp,
          model: value.model,
          pin: "",
          rentalIncome:
            value.bidType === "JD"
              ? value.rentalApplied.toString()
              : value.rentalApplied,
          saleAmtPerUnit: value.salePrice.toString(),
          make: value.manufacturer,
          paymentType: {
            monthlyPayment: value.leasePayment,
            cashDown: value.retailCashDown,
            finRate: value.retailFinRate,
            noOfMonths:
              action.payload.saleType === "LEASE_SALE"
                ? value.leaseMonths
                : action.payload.saleType === "RETAIL_NOTE_SALE"
                ? value.retailFinMonth
                : 0,
            paymentType:
              action.payload.saleType === "CASH_SALE"
                ? "Cash Sale"
                : action.payload.saleType === "LEASE_SALE"
                ? "Lease"
                : action.payload.saleType === "RETAIL_NOTE_SALE"
                ? "Retail Note"
                : null,
            pctAppldtoPurch: 0,
            purchOptAmt: value.leasePurchase,
          },
          totDiscountApplied:
            value.bidType === "JD"
              ? value.deereDiscApplied.toString()
              : value.deereDiscApplied,
          currency: value.currency,
          calcLeasePrice: value.calcLeasePrice.toString(),
          calcAdjustMacPrice: value.calcAdjustMacPrice.toString(),
          calcNormalizeTp: value.calcNormalizeTP.toString(),
          calcMachSpread: value.calcMachSpread.toString(),
          calcProgSpread: value.calcProgSpread.toString(),
          calcFinalSpread: value.calcFinalSpread.toString(),
          calcFinalSpreadPct: value.calcFinalSpreadPct.toString(),
          calcGrossMargin: value.calcGrossMargin.toString(),
          calcGrossMarginPct: value.calcGrossMarginPct.toString(),
          machSpecSmartgrade: value.machSpecSmartgrade,
          machSpecOther: value.machSpecOther,
        })),
      };
      newState = { ...transactionsData };
      return newState;

    case CLEAR_CREATE_TRANSACTION:
      newState = initialState;
      return newState;
    default:
      return state;
  }
}

export default transactionReducer;
